var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnNavBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8356 6.16809C16.9569 5.28941 15.5323 5.28941 14.6536 6.16809C13.7749 7.04677 13.7749 8.47139 14.6536 9.35007C15.5323 10.2288 16.9569 10.2288 17.8356 9.35007C18.7143 8.47139 18.7143 7.04677 17.8356 6.16809ZM15.7143 7.22875C16.0072 6.93586 16.482 6.93586 16.7749 7.22875C17.0678 7.52165 17.0678 7.99652 16.7749 8.28941C16.482 8.58231 16.0072 8.58231 15.7143 8.28941C15.4214 7.99652 15.4214 7.52165 15.7143 7.22875Z",
    fill: "#001412"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8836 4.87C21.8836 3.35121 20.6524 2.12 19.1336 2.12H13.8909C12.8964 2.12 11.9425 2.51508 11.2393 3.21834L2.92557 11.5321C1.85163 12.606 1.85163 14.3472 2.92557 15.4211L8.58243 21.078C9.65637 22.1519 11.3976 22.1519 12.4715 21.078L20.7852 12.7643C21.4885 12.061 21.8836 11.1072 21.8836 10.1126L21.8836 4.87ZM19.1336 3.61999C19.8239 3.62 20.3836 4.17964 20.3836 4.87L20.3836 10.1126C20.3836 10.7094 20.1465 11.2817 19.7246 11.7036L11.4109 20.0173C10.9227 20.5055 10.1312 20.5055 9.64309 20.0173L3.98623 14.3605C3.49808 13.8723 3.49808 13.0809 3.98623 12.5927L12.2999 4.279C12.7219 3.85705 13.2942 3.62 13.8909 3.62L19.1336 3.61999Z",
    fill: "#001412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNavBrands);
export default __webpack_public_path__ + "static/media/icn_nav_brands.53b8c46b3653764d3ac4e3b67e9cfcc2.svg";
export { ForwardRef as ReactComponent };